<template>
  <m-demo-box demo-option="businessType">
    <div slot="top">
      <m-demo-all-check />
    </div>
    <b-row>
      <b-col class="search-box">
        <b-input placeholde="Enter a SIC Code or Search Term Here"
                 v-model="searchKey"
                 :disabled="isAllHoseholds"
                 data-test="demo-businessType-search"
                 @input="search"></b-input>
        <span @click="search" class="search-btn"><icon name="search"/></span>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="box-t" :class="{disabled: isAllHoseholds}">
          <div>
            <span href="javascript:void(0)" class="item-btns">Add</span>
            <span href="javascript:void(0)" class="item-btns">Omit</span>
            <b-link href="javascript:void(0)" class="item-btns" @click="removeAll" data-test="demo-businessType-clearAll">Clear All</b-link>
          </div>
          <div class="sicitem">
          <business-type-item v-for="item in demos"
                              :item="item"
                              :key="item.data"
                              v-if="!isSearch" :data-test="`demo-businessType-itemName-${item.data}`"/>
          <business-type-search-item v-for="item in searchDemos"
                                     :item="item"
                                     :key="item.data"
                                     v-if="isSearch"/>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col>
        <b-link href="javascript:void(0)"
                class="clear-selection"
                :class="{disabled: isAllHoseholds}"
                @click="removeAllAdd"
                data-test="demo-businessType-removeAll">Clear
          Selection</b-link>
        <h4>My Selected Industries</h4>
        <div class="box-t select" :class="{disabled: isAllHoseholds}">
          <div v-for="item in selectAddItem">
            {{item.AttributeValueName}}
            <b-link href="javascript:void(0)"
                    class="selected-remove"
                    @click="removeAdd(item)"
                    data-test="demo-businessType-remove">Remove</b-link>
          </div>
        </div>
      </b-col>
      <b-col>
        <b-link href="javascript:void(0)"
                class="clear-selection"
                :class="{disabled: isAllHoseholds}"
                @click="removeAllOmit"
                data-test="demo-businessType-removeAllOmit">Clear
          Selection</b-link>
        <h4>My Omitted Industries</h4>
        <div class="box-t select" :class="{disabled: isAllHoseholds}">
          <div v-for="item in selectOmitItem">
            {{item.AttributeValueName}}
            <b-link href="javascript:void(0)"
                    class="selected-remove"
                    @click="removeOmit(item)"
                    data-test="demo-businessType-removeOmit">Remove</b-link>
          </div>
        </div>
      </b-col>
    </b-row>

  </m-demo-box>
</template>

<script>
  import MDemoAllCheck from '@/components/demo/MDemoAllCheck'
  import MDemoBox from '@/components/demo/MDemoBox'
  import BusinessTypeItem from '@/components/demo/BusinessTypeItem'
  import BusinessTypeSearchItem from '@/components/demo/BusinessTypeSearchItem'

  export default {
    components: {
      MDemoBox,
      MDemoAllCheck,
      BusinessTypeItem,
      BusinessTypeSearchItem
    },
    data () {
      return {
        searchKey: '',
        demos: [],
        searchDemos: [],
        isSearch: false
      }
    },
    computed: {
      listType () {
        if (this.$store.state.order.ListType) {
          return this.$store.state.order.ListType
        } else {
          return 10
        }
      },
      SICs () {
        return this.$store.state.demo.SICs
      },
      isAllHoseholds () {
        return this.$store.getters['order/isAllHoseholds']
      },
      selectAddItem () {
        return this.$store.getters['order/demoBusinessTypeAddItem']
      },
      selectOmitItem () {
        return this.$store.getters['order/demoBusinessTypeOmitItem']
      }
    },
    created () {
      this.getData()
    },
    watch: {
      '$route.params.listType' () {
        this.getData()
      }
    },
    methods: {
      getData () {
        this.demos = []
        this.$http.post('PlaceOrder.aspx/GetChildrenBySICCode', {
          id: '',
          listType: this.listType
        }).then(resp => {
          this.demos = resp.body.d.DataSource
        })
      },
      search () {
        if (this.searchKey === '') {
          this.isSearch = false
          return
        }
        this.isSearch = true
        this.$http.post('PlaceOrder.aspx/SearchSICByKeyword', {
          keyword: this.searchKey,
          listType: this.listType
        }, {
          abortPre: true
        }).then(resp => {
          this.searchDemos = resp.body.d.DataSource
        })
      },
      removeAdd (item) {
        this.$store.dispatch('order/toggleAddDemoBusinessType', {
          val: false,
          industryCode: item.AttributeValue,
          IndustryDesc: item.AttributeValueName
        })
      },
      removeOmit (item) {
        this.$store.dispatch('order/toggleOmitDemoBusinessType', {
          val: false,
          industryCode: item.AttributeValue,
          IndustryDesc: item.AttributeValueName
        })
      },
      removeAllAdd () {
        this.$store.dispatch('order/deleteDemo', {
          type: 'column',
          columnName: 7,
          demoCategoryType: 4
        })
      },
      removeAllOmit () {
        this.$store.dispatch('order/deleteDemo', {
          type: 'column',
          columnName: 7,
          demoCategoryType: 6
        })
      },
      removeAll () {
        this.removeAllAdd()
        this.removeAllOmit()
      }
    }
  }
</script>

<style scoped lang="scss">
  .box-t {
    width: 100%;
    display: block;
    border: 1px solid #ccc; /* Pony@ma need regular css */
    height: 300px;
    margin-top: 16px;
    margin-bottom: 16px;
  }
  .sicitem {
    overflow: auto;
    height: 280px;
  }
  .disabled{
    pointer-events: none;
    cursor: default;
    opacity: 0.6;
  }
  .box-t.disabled {
    pointer-events: none;
    cursor: default;
    opacity: 0.6;
    background-color: #e9ecef;
  }
  .box-t.select {
    height: 200px;
    overflow: auto;
    padding: 0 10px;
  }
  .clear-selection {
    float: right;
    margin-top: 4px;
  }
  .item-btns{
    padding-right: 8px;
    padding-left: 8px;
  }
  .selected-remove {
    margin-left: 16px;
  }
  .search-box {
    position: relative;
  }
  .search-btn {
    padding:8px;
    position: absolute;
    right: 32px;
    top: -8px;
    font-size: 24px;
    cursor:pointer;
  }
</style>



// WEBPACK FOOTER //
// src/pages/order/DemoBusinessType.vue